import { departmentDashboard } from '../../actions/constant';

const {
  GET_PHYSICIAN_SIGNATURE_PENDING_SUCCESS,
  GET_PHYSICIAN_SIGNATURE_PENDING_FAILURE,
  GET_PHYSICIAN_SIGNATURE_PENDING_LOADING,
  GET_PHYSICIAN_SIGNATURE_PENDING_RESET,
} = departmentDashboard;

const initialState: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getPhysicianSignaturePendingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PHYSICIAN_SIGNATURE_PENDING_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_PHYSICIAN_SIGNATURE_PENDING_SUCCESS:
      return {
        ...state,
        isError: false,
        loading: false,
        response: action.payload?.data,
      };
    case GET_PHYSICIAN_SIGNATURE_PENDING_FAILURE:
      return {
        ...state,
        isError: true,
        loading: false,
        errorMessage: action.payload,
        response: null,
      };
    case GET_PHYSICIAN_SIGNATURE_PENDING_RESET:
      return initialState;
    default:
      return state;
  }
};
